module.exports = __webpack_public_path__ + "img/popup_battery_5.8f35b4de.svg";